import { handleTrack } from '../../../../../utils/tracker';
import { ButtonVariants } from '../../../../Atoms/Button';
import { ButtonWithAnchor } from '../../../../income-tax/page-sections/hero-section/sticky-button';

interface IARTICLE_LIST {
  article:
    | {
        title?: string;
        list: Array<{
          id: string;
          title: string;
          link: string;
        }>;
      }
    | [];
  handleClick?: () => void;
  button?: {
    text: string;
    link: string;
  };
}

export const ArticleList = ({
  article,
  handleClick,
  button,
}: IARTICLE_LIST) => {
  if (Array.isArray(article)) {
    return <></>;
  }
  return (
    <div className="p-6 bg-grey-100 rounded-md">
      <div className="text-s-16 font-bold mb-4">{article.title}</div>
      {article.list?.map((item) => {
        return (
          <div
            className="tocItem font-medium cursor-pointer text-base mb-4 list-none"
            key={item.id}
            onClick={(e) => {
              handleTrack({
                label: 'rhs_cta',
                obj: e.target,
              });
            }}
          >
            <a
              onClick={handleClick}
              href={item.link}
              className="text-font-500 hover:text-blue-350 text-s-14"
            >
              {item.title}
            </a>
          </div>
        );
      })}
      {button ? (
        <ButtonWithAnchor
          className="text-base font-bold px-0 py-4"
          buttonVariant={ButtonVariants.bluetext}
          buttonLink={button.link}
          buttonText={button?.text}
          trackLabel="toc"
        />
      ) : null}
    </div>
  );
};
